import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import '../css/pieQuiz.css';

const data = [
  { name: 'Part 1', value: 1 },
  { name: 'Part 2', value: 1 },
  { name: 'Part 3', value: 1 },
  { name: 'Part 4', value: 1 },
  { name: 'Part 5', value: 1 },
  { name: 'Part 6', value: 1 },
  { name: 'Part 7', value: 1 },
];

// Liste des couleurs pour chaque part
const COLORS = ['#6F3F89', '#375A9C', '#029FB2', '#29A648', '#E0B614', '#DA5E20', '#C11D24'];

const PieQuizComponent = ({ currentQuestion }) => {
  const [rotationAngle, setRotationAngle] = useState(0);
  const [isFirstRender, setIsFirstRender] = useState(true); // État pour gérer le premier rendu

  // Calcul des valeurs sectionAngle et initialOffset après le premier rendu
  const sectionAngle = 360 / data.length; // Angle d'une section
  const initialOffset = 90 + sectionAngle / 2; // Alignement de la première section en haut

  useEffect(() => {
    // Calcul de l'angle de rotation basé sur la question actuelle
    const newAngle = initialOffset + ((currentQuestion - 1) * sectionAngle);
    setRotationAngle(newAngle);

    // Désactiver l'animation au premier rendu
    if (isFirstRender) {
      setIsFirstRender(false); // Le premier rendu est maintenant effectué
    }
  }, [currentQuestion, isFirstRender, sectionAngle, initialOffset]);

  return (
    <div className="pie-quiz-container">
      {/* Conteneur rotatif */}
      <div
        className="pie-quiz-responsive"
        style={{
          transform: `rotate(-${rotationAngle}deg)`, // Rotation dans le sens antihoraire
          transition: isFirstRender ? 'none' : 'transform 1s ease-in-out', // Pas de transition pour le premier rendu, sinon animation
        }}
      >
        <ResponsiveContainer width="100%" height={300}>
          <PieChart animationDuration={0}>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
              animationDuration={0}
            >
              {data.map((entry, index) => {
                const isHighlighted = 7 - currentQuestion === index;

                return (
                  <Cell
                    key={`cell-${index}`} // Utilisation d'une clé simple
                    fill={COLORS[index % COLORS.length]}
                    style={{
                      transform: isHighlighted ? 'scale(1.2)' : 'scale(1)', // Agrandissement de la cellule mise en surbrillance
                      transformOrigin: 'center', // Point d'origine pour l'échelle
                      transition: 'transform 2s ease-in-out', // Animation de mise à l'échelle de 2 secondes
                    }}
                  />
                );
              })}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      {/* Texte centré */}
      <div className="centered-quiz-text">Quiz</div>
    </div>
  );
};

export default PieQuizComponent;
